import React from "react"
import PropTypes from "prop-types"

const FaTimes = ({ height, width, color, innerClassName }) => (
  <svg
    className={innerClassName}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    viewBox="0 0 14 14"
  >
    <path
      style={{ fill: color }}
      d="M8.57 8.43l-1.141 1.141q-0.078 0.078-0.18 0.078t-0.18-0.078l-1.070-1.070-1.070 1.070q-0.078 0.078-0.18 0.078t-0.18-0.078l-1.141-1.141q-0.078-0.078-0.078-0.18t0.078-0.18l1.070-1.070-1.070-1.070q-0.078-0.078-0.078-0.18t0.078-0.18l1.141-1.141q0.078-0.078 0.18-0.078t0.18 0.078l1.070 1.070 1.070-1.070q0.078-0.078 0.18-0.078t0.18 0.078l1.141 1.141q0.078 0.078 0.078 0.18t-0.078 0.18l-1.070 1.070 1.070 1.070q0.078 0.078 0.078 0.18t-0.078 0.18zM10.25 7q0-1.156-0.57-2.133t-1.547-1.547-2.133-0.57-2.133 0.57-1.547 1.547-0.57 2.133 0.57 2.133 1.547 1.547 2.133 0.57 2.133-0.57 1.547-1.547 0.57-2.133zM12 7q0 1.633-0.805 3.012t-2.184 2.184-3.012 0.805-3.012-0.805-2.184-2.184-0.805-3.012 0.805-3.012 2.184-2.184 3.012-0.805 3.012 0.805 2.184 2.184 0.805 3.012z"
    />
  </svg>
)

FaTimes.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  color: PropTypes.string,
  innerClassName: PropTypes.string,
}

FaTimes.defaultProps = {
  height: "14",
  width: "14",
  color: "#000000",
}

export default FaTimes
